export const handleChange = (event, fields, setFunction) => {
  const { name, value } = event.target;
  setFunction({ ...fields, [name]: value });
};
export const handleSignInSubmit = async (event, fields, loaderFunction) => {
  event.preventDefault();
  loaderFunction("aho1-loader-visible");
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/user/auth/login",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(fields),
      }
    );
    const result = await response.json();
    localStorage.setItem("user", result["tokenValue"]);
    localStorage.setItem("hotelID", result["hotelID"]);
    localStorage.setItem("navigationFolder", "HOME");
    window.location.reload();
  } catch (error) {
    alert(error.message);
  }
  loaderFunction("aho1-loader-hidden");
};
export const handleSignUpSubmit = async (
  event,
  fields,
  adminPassword,
  confirmPassword,
  loaderFunction
) => {
  event.preventDefault();
  if (adminPassword === confirmPassword) {
    loaderFunction("aho1-loader-visible");
    try {
      const response = await fetch(
        "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/user/auth/register",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify(fields),
        }
      );
      const result = await response.json();

      if (response.status !== 400) {
        localStorage.setItem("user", result["tokenValue"]);
        localStorage.setItem("hotelID", result["hotelID"]);
        localStorage.setItem("navigationFolder", "HOME");
        window.location.reload();
      }
    } catch (error) {
      alert(error);
      return;
    }
    loaderFunction("aho1-loader-hidden");
  }
};
export const passwordChange = (event, varFunction) => {
  varFunction(event.target.value);
};
export const signInInitial = {
  email: "",
  password: "",
};
export const signUpInitial = {
  restaurantName: "",
  restaurantEmail: "",
  adminName: "",
  adminPassword: "",
};
